var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var _destroyed;
import { siteswapGraph } from "./generator.impl";
export class SiteswapGenerator {
    constructor(config) {
        _destroyed.set(this, false);
        siteswapGraph({
            minPeriod: 1,
            maxPeriod: config.maxHeight,
            numProps: config.propCount,
            maxSiteswaps: 200,
            includeExcited: false,
            includeMultiplex: config.multiplex,
            async: true,
            sync: config.sync,
            callbacks: {
                graphDone: () => {
                    if (!__classPrivateFieldGet(this, _destroyed)) {
                        config.onDone();
                    }
                },
                updateGraphProgress: (p) => {
                    return !__classPrivateFieldGet(this, _destroyed);
                },
                siteswapFound: (a, b, c) => {
                    if (!__classPrivateFieldGet(this, _destroyed)) {
                        config.onSiteswapFound(a);
                    }
                },
            },
        });
    }
    destroy() {
        __classPrivateFieldSet(this, _destroyed, true);
    }
}
_destroyed = new WeakMap();
